<template>
  <Modal :id="'cmp-create-info'" @cancelled="onCancel">
    <template slot="header">{{title}}</template>
    <template slot="body" :class="{
        'dt-loading': loading
      }">
      <v-layout row wrap>
        <v-flex md3>
          <div class="form-group">
            <TextField
              :id="'infoName'"
              required
              v-bind="textFieldConfig"
              v-model="infoName"
              isModel
              :placeholder="$t('info_name')"
              @valuechanged="onTextFieldValueChange"
            ></TextField>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="ckeditor-container" mt-3>
        <!-- <ckeditor ref="ckeditor" :editor="editor" v-model="infoText" :config="editorConfig"></ckeditor> -->
        <HtmlEditor v-model="infoText"></HtmlEditor>
      </v-layout>
    </template>
    <template slot="options">
      <button class="dt-button v1 s7" @click.stop="onAddInfo">{{buttonTitle}}</button>
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import HtmlEditor from "@plugins/html-editor/html-editor";

import { ArtistService } from "../../../services/artists";
import { isNotEmptyString, RouteError } from "../../../../../utility";
import Modal from "../../../../../dt-plugins/modal/modal";

export default {
  components: {
    TextField,
    HtmlEditor,
    Modal
  },
  props: {},
  data: function() {
    return {
      infoName: "",
      infoText: "",

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      loading: false
      // Mark: Data
    };
  },
  mounted: function() {
    if (this.modal === "edit_info") {
      if ([this.artistInfoId, this.artistId].some(e => !isNotEmptyString(e))) {
        this.onCancel();
        throw RouteError("Provide Artist Info ID and Artist ID in the query");
      }
      this.loading = true;

      //TODO: Change the implementation from a online query to a store based data passing. It will be based on the re-usability use case.
      ArtistService.editInfo({
        artistInfoId: this.artistInfoId,
        artistId: this.artistId
      }).then(res => {
        this.infoName = res.data.artistinfo.artist_info_name;
        this.infoText = res.data.artistinfo.info_txt;

        this.loading = false;
      });
    } else if (this.modal === "create_info") {
      if ([this.artistId].some(e => !isNotEmptyString(e))) {
        this.onCancel();
        throw RouteError("Provide Artist ID in the query");
      }
    }
  },
  watch: {},
  computed: {
    title: function() {
      const title = this.$route.query.modal;
      if (title === "create_info") {
        return `${this.$t("add")} ${this.$t("related_info")}`;
      } else if (title === "edit_info") {
        return this.$t("edit_related_info");
      }
      return title;
    },
    buttonTitle: function() {
      return this.modal === "edit_info"
        ? this.$t("ok")
        : this.modal === "create_info"
        ? `${this.$t("add")} ${this.$t("new")} ${this.$t("related_info")}`
        : this.$t("ok");
    },
    modal: function() {
      return this.$route.query.modal;
    },
    artistId: function() {
      return this.$route.query.artist_id;
    },
    artistInfoId: function() {
      return this.$route.query.artist_info_id;
    }
  },
  methods: {
    onAddInfo: function(event) {
      if (this.modal === "edit_info") {
        ArtistService.modifyInfo({
          artistInfoId: this.artistInfoId,
          infoName: this.infoName,
          infoText: this.infoText
        }).then(res => {
          this.$emit("added", this.artistId);
        });
      } else if (this.modal === "create_info") {
        ArtistService.insertRelatedInfo({
          artistId: this.artistId,
          infoName: this.infoName,
          infoTxt: this.infoText
        }).then(res => {
          this.$emit("added", this.artistId);
        });
      }
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(key, value) {
      this.infoName = value;
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
.dt-loading {
  .ckeditor-container {
    // opacity: 0.5;
  }
}
</style>
